export default __webpack_public_path__ + "static/media/Ring-Bread.e28a37cd.jpg";